import * as common from "appdevresources/common";
import dataTables from "appdevresources/datatables";
import "appdevresources/twig.jquery";
import Routing from "appdevresources/router";

let messageModalInterval = null;
let unreadMessageCountInterval = null;
let messageTable = null;
let modalCount = 0;

$(async function () {
    const twig = $.twig();
    const siteContext = twig.get("siteContext");

    $(".openMsgLink").on("click", function () {
        $("#viewMessageListModal").modal("show");
    });

    if ($(".messageCountSpinner").length > 0) {
        getUnreadMessageCountOnInterval();
    }

    // This is a hack that will ensure the .model-open class is only removed from the <body> element if and when there
    // are no more modals open. By default, closing a second modal (e.g., replying to a message) will make bootstrap
    // think all modals are closed and remove .modal-open, which will cause (at minimum) scrolling issues with the main
    // modal.
    $(document)
        .on("shown.bs.modal", () => ++modalCount)
        .on("hidden.bs.modal", function() {
            if (--modalCount >= 1) {
                $("body").addClass("modal-open");
            } else {
                // Ensure we do not somehow get into the negatives.
                modalCount = 0;
            }
        });

    $("#viewMessageListModal").off("hidden.bs.modal").on("hidden.bs.modal", function () {
        $("#modalAlertText").html("");
    });

    $("#replyMessageModal").off("hidden.bs.modal").on("hidden.bs.modal", function () {
        $("#viewMessageListModal").modal("show");
    });

    $("#btnReply").off("click.reply").on("click.reply", function () {
        $("#viewMessageListModal").modal("hide");
        $("#viewMessageModal").modal("hide");
        $("#replyMessageModal").modal("show");
    });

    $("#btnSendReply").off("click.sendReply").on("click.sendReply", function () {
        common.loadSpinner();

        if (common.validateRequired("replyMessageForm")) {
            sendReply();
        } else {
            common.unloadSpinner();
        }
    });

    $("#btnSendMessage").off("click.sendNewMsg").on("click.sendNewMsg", function () {
        common.loadSpinner();

        if (common.validateRequired("newMessageForm")) {
            sendNewMessage();
        } else {
            common.unloadSpinner();
        }
    });

    $(".sendNewMessage").off("click.newMsgOpen").on("click.newMsgOpen", function () {
        //slower browser loads won't fire this - so a very small delay is necessary
        setTimeout(function () {
            $("#newMessageModal").modal("show");
        }, 300);
    });

    messageTable = await dataTables.create($("#modalMessageTable"), {
        rowId: "messagePK",
        ajax: {
            dataSrc: "",
            url: Routing.generate("api_readAndUnread_messages", {siteContext: siteContext})
        },
        columns: [
            {
                data: "sendDate",
                render: (data, type) => {
                    if (type === "sort" || type === "filter") {
                        return Date.parse(data);
                    }
                    return data;
                },
            },
            {data: "fromName"},
            {data: "subject"},
            {data: "shortBody"},
            {
                orderable: false,
                data: null,
                render: () => {
                    return "<span class='message-view-open-modal cursor-override-pointer' data-toggle='tooltip' title='Read this message.'><i class='fa fa-lg fa-envelope-open-text'></i></span> <span class='message-reply-open-modal cursor-override-pointer' data-toggle='tooltip' title='Reply To this message.'><i class='fa fa-lg fa-reply'></i></span> <span class='message-markarchive cursor-override-pointer' data-toggle='tooltip' title='Archive this message.'><i class='fa fa-lg fa-archive'></i></span>";
                }
            }
        ],
        language: {
            emptyTable: "No messages found. All messages may be archived."
        },
        responsive: false,
        initComplete: function () {
            common.unloadSpinner();
            common.initializeToolTips();
        },
        createdRow: function (row, data) {
            if (data.readDate == null) {
                $(row).addClass("unread-message-row");
            }
            let tooltip = data.bodyBreaks;
            tooltip = tooltip.replace(/<br\s*[\/]?>/gi,"\n");
            $(row).attr("title",tooltip);
        },
        order: [[0, "desc"]]
    });

    if (!messageModalInterval) {
        //reload every 2 minutes
        messageModalInterval = setInterval(function () {
            messageTable.ajax.reload();
        }, 120000);
    }

    $("#modalMessageTable").off("click.viewOpen").on("click.viewOpen", ".message-view-open-modal", function() {
        common.loadSpinner();

        getModalMessageContent($(this).parents("tr").attr("id"));
    });

    $("#modalMessageTable").off("click.markArchive").on("click.markArchive", ".message-markarchive", function () {
        common.loadSpinner();

        clearInterval(messageModalInterval);
        archiveMessage($(this).parents("tr").attr("id"));
    });

    $("#modalMessageTable").off("click.replyOpen").on("click.replyOpen", ".message-reply-open-modal", function() {
        common.loadSpinner();

        getModalMessageContent($(this).parents("tr").attr("id"), true);
    });

    $("#modalMessageTable").on("draw.dt",function () {
        common.initializeToolTips();
    });

    if ($("#archiveMessageTable").length) {
        await dataTables.create($("#archiveMessageTable"), {
            columnDefs: [
                {
                    targets: ["th-action"],
                    orderable: false,
                    visible: true
                },
                {
                    targets: ["th-hide-but-search"],
                    orderable: false,
                    searchable: true,
                    visible: false
                }
            ],
            order: [[0, "desc"]],
            language: {
                emptyTable: "No messages found. All messages may be archived."
            },
            responsive: false
        });

        $("#archiveMessageTable").off("click.viewArchiveOpen").on("click.viewArchiveOpen", ".message-view-archive-open-modal", function () {
            common.loadSpinner();
            getModalMessageContent($(this).data("id"), false, false);
        });
    }

    //get the count of unread messages for the message count interface
    function getUnreadMessageCount(initial) {
        let initialCount = 0;
        if (initial) {
            common.loadMiniSpinner($(".messageCountSpinner"));
        }
        else {
            initialCount = parseInt($(".messageCount").html());
        }
        $.getJSON(Routing.generate("api_unread_messages_count", {siteContext: siteContext}))
            .always(function(json) {
                setTimeout(function() {
                    $(".messageCount").html(json.recordsTotal);
                    common.unloadMiniSpinner($(".messageCountSpinner"));
                    if (!initial && initialCount < parseInt(json.recordsTotal)) {
                        common.loadAlert("<strong>A new message has arrived.</strong>", {alertType: "success"});
                    }
                },100);
            })
            .fail(function(){
                $(".messageCount").html(0);
            });
    }

    //initialize the unread count on a 60 second interval
    function getUnreadMessageCountOnInterval()
    {
        getUnreadMessageCount(true);
        if (!unreadMessageCountInterval) {
            unreadMessageCountInterval = setInterval(function () {
                getUnreadMessageCount(false);
            }, 120000); //every 2 minutes
        }
    }
    //archive the chosen message
    function archiveMessage(messageId) {
        $.getJSON(Routing.generate("api_mark_archive_message", {siteContext: siteContext, id: messageId}))
            .done(function() {
                messageTable.ajax.reload();
                getUnreadMessageCount(false);
                common.loadAlert("Message has been archived.", {alertType: "success"});
            })
            .fail(function(jqXHR, textStatus, errorThrown){
                common.loadAlert(`System Error: ${errorThrown}. Please contact the OneIT Helpdesk for support.`, {alertType: "danger"});
            })
            .always(function () {
                common.unloadSpinner();
            })
    }

    //send reply
    function sendReply()
    {
        $("#modalAlertText").html("");
        let postData = {
            oi: $("#oi").val(),
            subject: $("#replyMessageSubject").val(),
            program: siteContext === "S" ? "" : $("#op").val(),
            body: $("#replyMessageContent").val(),
            _csrf_token: $("[name='_csrf_token']","#replyMessageForm").val()
        };
        $.post(Routing.generate("api_reply_message", {siteContext: siteContext}), postData)
            .done(function () {
                common.loadAlert("Reply has been sent.", {alertType: "success"});
                $("#replyMessageModal").modal("hide");
                messageTable.ajax.reload();
                getUnreadMessageCount(false);
                $("#viewMessageListModal").modal("show");
            })
            .fail(function (qXHR, textStatus, errorThrown) {
                common.loadAlert("There was an error sending your reply. Please contact the OneIT Helpdesk for support.", {alertType: "danger"});
            })
            .always(function () {
                common.unloadSpinner();
            });
    }

    //send new message
    function sendNewMessage()
    {
        let postData = {
            subject: $("#newMessageSubject").val(),
            program: siteContext === "S" ? "" : $("#newMessageProgram").val(),
            body: $("#newMessageContent").val(),
            _csrf_token: $("[name='_csrf_token']","#newMessageForm").val()
        };
        $.post(Routing.generate("api_new_message", {siteContext: siteContext}), postData)
            .done(function () {
                $("#newMessageModal").modal("hide");
                $("#newMessageSubject").val("");
                $("#newMessageContent").val("");
                common.loadAlert("Message has been sent.", {alertType: "success"});
            })
            .fail(function (qXHR, textStatus, errorThrown) {
                common.loadAlert(`Error sending new message: ${errorThrown}. Please contact the OneIT Helpdesk for support.`, {alertType: "danger"});
            })
            .always(function () {
                common.unloadSpinner();
            });
    }

    //get the chosen message content and populate both the view and reply modals
    function getModalMessageContent(messageId, reply = false, sourceModal = true)
    {
        $("#replyMessageFromName, #viewMessageFromName").val("");
        $("#replyMessageDateSent, #viewMessageDateSent").html("");
        $("#replyMessageSubject").html("");
        $("#viewMessageSubject").val("");
        $("#replyMessageProgram, #viewMessageProgram").html("");
        $("#viewMessageContent").html("");
        $("#replyMessageContent").val("");

        $.getJSON(Routing.generate("api_specific_message", {siteContext: siteContext, id: messageId}))
            .done(function(json) {
                let fromName = json.fromName;
                let sendDate = json.sendDate;
                let subject = json.subject;
                let program = json.programDesc;
                let bodyContentBreaks = json.bodyBreaks;
                let bodyContentRaw = json.bodyNoBreaks;
                let origId = json.messagePK;
                let origProgCode = json.programCode;

                let replySubject = `Re: ${subject}`;
                let replyMessage = `\r\n\r\n\r\n------------------------------------------\r\nSent By: ${fromName} - ${json.fromUsername} (${sendDate})\r\n${bodyContentRaw}`;

                $("#replyMessageFromName, #viewMessageFromName").html(fromName);
                $("#replyMessageDateSent, #viewMessageDateSent").html(sendDate);
                $("#viewMessageSubject").html(subject);
                $("#replyMessageSubject").val(replySubject);
                $("#replyMessageProgram, #viewMessageProgram").html(program);
                $("#viewMessageContent").html(bodyContentBreaks);
                $("#replyMessageContent").val(replyMessage);
                $("#oi").val(origId);
                $("#op").val(origProgCode);

                if (sourceModal) {
                    messageTable.ajax.reload();
                    getUnreadMessageCount(false);
                    $("#btnReply").show();
                } else {
                    $("#btnReply").hide();
                }

                if (reply) {
                    $("#replyMessageModal").modal("show");
                } else {
                    $("#viewMessageModal").modal("show");
                }
            })
            .fail(function(){
                common.loadAlert("There was an error loading the messages. Please contact the OneIT Helpdesk for support.", {alertType: "danger"});
            })
            .always(function () {
                common.unloadSpinner();
            });
    }
});

console.debug("Loaded library: messages");
